'use strict';

import api from '../../api';

export default {
  namespaced: true,
  state: {
    offers: []
  },
  mutations: {
    setOffers(state, offers) {
      state.offers = offers;
    }
  },
  actions: {
    loadPoolParticipationOffers({commit}) {
      api.PoolParticipationOffer.index({})
        .then(offers => commit('setOffers', offers));
    }
  },
  getters: {
    offers(state) {
      return state.offers;
    }
  }
};
